import { AUTHORITIES as APP_AUTHORITIES } from 'domain/fuse/auth/constants';

export const AUTHORITIES = [APP_AUTHORITIES.ACCOUNT_ADMIN];

export const ROUTES = {
  ROOT: '/shipment-alerts',
};
